
// import React from 'react';
// import './HeroSection.css';
// import { Link } from 'react-router-dom';

// export default function HeroSection() {
//   return (
//     <div className="hero-wrapper" id="home">
//       {/* Hero Content Section */}
//       <section className="hero-body">
//         <div className="hero-content">
        

//           <h2 className="hero-title">
//             Centre for Distance <br />
//             <span className="highlight-yellow">and Online Education</span>
//           </h2>
          
//           <h3 className="hero-subtitle">EDULEARNER</h3>
          
//           <p className="hero-details">
//             Prospectus – Academic Year 2025–26 | July Session Admission <br />
//             Thiruvannamalai, India
//           </p>

//           <div className="cta-group">
//                       <Link to="/enquiry">
//             <button className="btn-primary">
//               Apply Now <span className="arrow">➔</span> 
//             </button>
//             </Link>
//               <Link to="/prospectus">
//             <button className="btn-secondary">
//               <span className="icon">📥</span> Download Prospectus
//             </button></Link>
//              <Link to="/programs">
//             <button className="btn-outline">
//               View Programs
//             </button>
//             </Link>
//           </div>

//           <div className="accreditation-tags">
//             <span className="tag"><span className="check">✓</span> UGC Recognized</span>
//             <span className="tag"><span className="check">✓</span> NAAC A++</span>
//             <span className="tag"><span className="check">✓</span> NIRF Ranked</span>
//             <span className="tag"><span className="check">✓</span> AICTE Approved</span>
//           </div>
//         </div>
// {/*         
//         <div className="scroll-indicator">
//           SCROLL
//         </div> */}
//       </section>
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './HeroSection.css';

export default function HeroSection() {
  const [sliders, setSliders] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const timerRef = useRef(null);

  const defaultSlide = {
    heading: 'Centre for Distance and Online Education',
    description: 'Prospectus – Academic Year 2026–27 | July Session Admission\nThiruvannamalai, India',
    slider_image_url: 'https://images.unsplash.com/photo-1562774053-701939374585?w=1600&h=900&fit=crop&auto=format',
    header_logo_url: null,
    cta_text: 'Apply Now',
    cta_link: '/enquiry'
  };

  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await fetch('https://metapi.emedhatechnologies.com/api/hero-sliders/hero-sliders');
        const result = await response.json();

        if (result.success && Array.isArray(result.data) && result.data.length > 0) {
          setSliders(result.data);
        } else {
          setSliders([defaultSlide]);
        }
      } catch (error) {
        console.error('Error loading hero sliders:', error);
        setSliders([defaultSlide]);
      } finally {
        setLoading(false);
      }
    };

    fetchSliders();
  }, []);

  const startAutoScroll = () => {
    stopAutoScroll();
    timerRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % (sliders.length || 1));
    }, 6000);
  };

  const stopAutoScroll = () => {
    if (timerRef.current) clearInterval(timerRef.current);
  };

  useEffect(() => {
    if (sliders.length > 1) {
      startAutoScroll();
    }
    return () => stopAutoScroll();
  }, [sliders, currentIndex]);

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % sliders.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + sliders.length) % sliders.length);
  };

  const activeSlide = sliders[currentIndex] || defaultSlide;

  return (
    <div className="hero-wrapper" id="home" onMouseEnter={stopAutoScroll} onMouseLeave={startAutoScroll}>
      
      {/* Light Overlay Background Layer */}
      <div
        className="hero-body-slide"
        style={{
          backgroundImage: `linear-gradient(rgba(10, 37, 64, 0.45), rgba(10, 37, 64, 0.50)), url('${activeSlide.slider_image_url}')`
        }}
      >
        {/* Left Arrow Control */}
        {sliders.length > 1 && (
          <button className="slider-arrow left-arrow" onClick={handlePrev} aria-label="Previous Slide">
            ❮
          </button>
        )}

        {/* Hero Main Content */}
        <div className="hero-content">
          
          {/* Header Title with Optional Logo */}
          <div className="title-logo-header-row">
            {activeSlide.header_logo_url && (
              <div className="slide-header-logo-box">
                <img src={activeSlide.header_logo_url} alt="University Header Logo" />
              </div>
            )}
            <h2 className="hero-title">
              {activeSlide.heading || 'Centre for Distance and Online Education'}
            </h2>
          </div>

          <h3 className="hero-subtitle">EDULEARNER</h3>

          {/* Description Paragraph */}
          {activeSlide.description && (
            <p className="hero-details">{activeSlide.description}</p>
          )}

          {/* CTA Action Buttons Group */}
          <div className="cta-group">
            {activeSlide.cta_text && activeSlide.cta_link ? (
              <Link to={activeSlide.cta_link} className="cta-link-item">
                <button className="btn-primary">
                  {activeSlide.cta_text} <span className="arrow">➔</span>
                </button>
              </Link>
            ) : (
              <Link to="/enquiry" className="cta-link-item">
                <button className="btn-primary">
                  Apply Now <span className="arrow">➔</span>
                </button>
              </Link>
            )}

            <Link to="/prospectus" className="cta-link-item">
              <button className="btn-secondary">
                <span className="icon">📥</span> Download Prospectus
              </button>
            </Link>
            <Link to="/programs" className="cta-link-item">
              <button className="btn-outline">
                View Programs
              </button>
            </Link>
          </div>

          {/* Accreditation Tags */}
          <div className="accreditation-tags">
            <span className="tag"><span className="check">✓</span> UGC Recognized</span>
            <span className="tag"><span className="check">✓</span> NAAC A++</span>
            <span className="tag"><span className="check">✓</span> NIRF Ranked</span>
            <span className="tag"><span className="check">✓</span> AICTE Approved</span>
          </div>

        </div>

        {/* Right Arrow Control */}
        {sliders.length > 1 && (
          <button className="slider-arrow right-arrow" onClick={handleNext} aria-label="Next Slide">
            ❯
          </button>
        )}

        {/* Slide Indicator Dots */}
        {sliders.length > 1 && (
          <div className="slider-dots-container">
            {sliders.map((_, idx) => (
              <span
                key={idx}
                className={`dot ${currentIndex === idx ? 'active-dot' : ''}`}
                onClick={() => setCurrentIndex(idx)}
              ></span>
            ))}
          </div>
        )}

      </div>

    </div>
  );
}